export default __webpack_public_path__ + "static/media/4b78837d609c549b75becb814def50cc.jpg";